import { TabContext, TabList, TabPanel } from "@mui/lab";
import { React, useCallback, useEffect, useState } from "react";
import TransTable from "../common/TransTable";
import _ from "lodash";
import { Box, Typography, IconButton, Tab, Stack, Button } from "@mui/material";
import { PageTitle } from "../common/PageTitle";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { base_url } from "../backendurl/url";
import { Notification } from "../common/Notification";
import ModalPopUp from "../common/TransForm/ModalPopUp";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import editicon from "../../images/editIcon.png";
import Iconify from "../common/Iconify";
import { utcTimetoLocalTimeWithzone } from "../common/TransForm/Localdateformater";
import Excel from "../../images/Excel.svg";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { setUsers } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { hasWritePermission } from "../common/PermissionUtility";
import CryptoJS from "crypto-js";


function Payouts() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
   const { users } = useSelector((state) => state);
  const [value, setValue] = useState("Failed Payouts");
  const [popup, setPopup] = useState(false);
  
  const [loading, setLoading] = useState(false);
  const [paymentData, setpaymentData] = useState([]);
  const [amountAdd, setAmountAdd] = useState(false);
  const [Amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState("USD");
  const tokenFlag = process.env.REACT_APP_TOKEN_FLAG;
  const [paymentMode, setpaymentMode] = useState("Cash");
  const [playerdetails, setplayerdetails] = useState("");
  const [errorMessage, setErrorMessage] = useState('')
  const [notification,setnotification] = useState(false);
      // Server-side pagination states
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('');
    const [sortBy, setSortBy] = useState('');
     // ADD THIS: Server-side search state
  const [searchQuery, setSearchQuery] = useState('');
  const canWriteUsers = hasWritePermission('payout');
  const [amountError, setAmountError] = useState('');

  const currencySymbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  // add more as needed
};
  console.log(paymentData, "paymentData");
  console.log(playerdetails, "playerdetails")

   // File Extension and Type for excel download
  const fileType ="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const handleNavigate = (data) => {
    navigate("/leagues/details", { state: data });
  };

  const headdata = [
    {
      player_id: "",
    },
  ];

   var derived_key = process.env.REACT_APP_ENCRYPTION_KEY
    ? CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_KEY)
    : null;
var iv = process.env.REACT_APP_IV
    ? CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV)
    : null;

const decryptAccountDetails = (encryptedData) => {
    if (!derived_key || !iv) return encryptedData || "N/A";
    const decrypted_initial = CryptoJS.AES.decrypt(encryptedData, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    const decrypted = CryptoJS.AES.decrypt(decrypted_initial, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
  };


  // Wrap decryption in a try-catch to prevent breaking Excel export
const safeDecryptAccountDetails = (encryptedData) => {
  try {
    if (!encryptedData || !derived_key || !iv) return "N/A";
    
    const decrypted_initial = CryptoJS.AES.decrypt(encryptedData, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    const decrypted = CryptoJS.AES.decrypt(decrypted_initial, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted || "N/A";
  } catch (error) {
    console.error("Decryption error:", error);
    return "N/A"; // Return N/A instead of throwing error
  }
};

  const payoutTableColumns = () => {
    let payoutTableColumns = [
      // {
      //   key: "id",
      //   label: "Player ID",
      //   align: "left",
      //   fontSize: "15px",
      //   // valueRenderer: (data) => {
      //   //   return (
      //   //     <Typography
      //   //       style={{ color: "#3C50E0", textUnderlineOffset: 7, textDecoration: 'underline', cursor: 'pointer', width: '180px' }}
      //   //       onClick={() => handleNavigate(data)}
      //   //     >
      //   //       {data["id"]}
      //   //     </Typography>
      //   //   );
      //   // },
      // },
      {
        key: "reference_number",
        label: "Payout ID",
        align: "left",
        fontSize: "15px",
      },
      {
        key: "reference_number",
        label: "Payment Method",
        align: "left",
        valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {data["reference_number"]} */}
              {"Payment Request"}
            </Typography>
          );
        },
      },
      {
        key: "username",
        label: "Player Name",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {data?.user_details["username"]}
            </Typography>
          );
        },
      },
      {
        key: "email",
        label: "Email",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography>
              {" "}
              {data?.user_details["email"]}
            </Typography>
          );
        },
       
      },
      {
        key: "mobile",
        label: "Mobile Number",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {data?.user_details["mobile"]}
            </Typography>
          );
        },
      },
       {
        key: "account_name",
        label: "Account Name",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {data?.bank_account_details?.account_name
    ? decryptAccountDetails(data.bank_account_details.account_name)
    : "N/A"}
            </Typography>
          );
        },
      },
      {
        key: "account_number",
        label: "Account Number",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {decryptAccountDetails(data?.bank_account_details["account_number"])} */}
              {data?.bank_account_details?.account_number
    ? decryptAccountDetails(data.bank_account_details.account_number)
    : "N/A"}
            </Typography>
          );
        },
      },
      {
        key: "bank_name",
        label: "Bank Name",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {data?.bank_account_details["bank_name"]} */}
               {data?.bank_account_details?.bank_name
    ? data.bank_account_details.bank_name
    : "N/A"}
            </Typography>
          );
        },
      },
      {
        key: "account_type",
        label: "Account Type",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {data?.bank_account_details["account_type"]} */}
               {data?.bank_account_details?.account_type
    ? data.bank_account_details.account_type
    : "N/A"}
            </Typography>
          );
        },
      },
      {
        key: "bank_address",
        label: "Bank Address",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {data?.bank_account_details["account_type"]} */}
               {data?.bank_account_details?.bank_address
    ? data.bank_account_details.bank_address
    : "N/A"}
            </Typography>
          );
        },
      },
         {
        key: "swift_code",
        label: "Swift Code",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {/* {decryptAccountDetails(data?.bank_account_details["swift_code"])} */}
               {data?.bank_account_details?.swift_code
    ? decryptAccountDetails(data.bank_account_details.swift_code)
    : "N/A"}
            </Typography>
          );
        },
      },
      // {
      //   key: "pot",
      //   label: "Round ID",
      //   align: "left",
      //   fontSize: "15px",

      //   // valueRenderer: (data) => {
      //   //   return (
      //   //     <Typography sx={{ width: '150px' }}> {data["pot"]}</Typography>
      //   //   )
      //   // },
      // },
      {
        key: "request_date",
        label: "Payment Date",
        align: "left",
        valueRenderer: (data) => {
          let date = utcTimetoLocalTimeWithzone(data["request_date"]);
          const [datePart, timePart] = date.split(", ");
          return <Typography sx={{ width: "150px" }}>{datePart}</Typography>;
        },
      },
      {
        key: "amount",
        label: "Amount Payable",
        align: "left",
        valueRenderer: (data) => {
          return (
            <Typography sx={{ width: "150px" }}>
              {" "}
              {data.currency_code} {data["amount"]}
            </Typography>
          );
        },
      },
      ...(canWriteUsers ? [{
        key: "amount_paid",
        label: "Amount Paid",
        align: "left",
        // valueRenderer: (data) => {
        //   return (
        //     <Typography sx={{ width: '150px' }}>{data["amount_paid"]}</Typography>
        //   )
        // }
        valueRenderer: (data) => {
          return (
            <Box sx={{ width: "180px" }}>
              <IconButton
                sx={{
                  "&:hover": {
                    // backgroundColor: 'transparent'
                    borderRadius: "12px",
                  },
                }}
                onClick={() => {
                  setAmountAdd(true);
                  setplayerdetails(data);
                  setAmount(0);
                  setCurrency("USD");
                  //setCurrency(data.currency_code);
                }}
              >
                <Typography
                  sx={{
                    color: "#3C50E0",
                    display: "flex",
                    gap: 2,
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {data.currency_code} {data.amount_processed || "0.00"}
                  <Iconify
                    icon={editicon}
                    type="image"
                    size="small"
                    color="primary.main"
                  />
                </Typography>
              </IconButton>
            </Box>
          );
        },
      }]: []),
      {
        key: "withdrawal_status",
        label: "Payment Status",
        align: "center",
        fontSize: '14px',
        
        // valueRenderer: (data) => {
        //   const colors = {
        //     COMPLETED :{ color:'#219653',backgroundColor:'#21965333'},
        //     NOT COMPLETED:{ color:'#E42C2C',backgroundColor:'#FFE8E1'},
        //     PARTIALLY COMPLETED:{ color:'#DD8A0D',backgroundColor:'#FEFFE1'}
        //   }
        // return <Button sx={{
  
        //   backgroundColor: `${colors[data?.withdrawal_status] ? colors[data?.withdrawal_status]?.backgroundColor :'#FFE8E1'}`,
        //    color:`${colors[data?.withdrawal_status]?.color ?colors[data?.withdrawal_status]?.color:'#E42C2C'}`}}>{data?.withdrawal_status}</Button>
        // },
        valueRenderer: (data) => {
    const colors = {
      COMPLETED: { color: "#219653", backgroundColor: "#21965333" },
      NOT_COMPLETED: { color: "#E42C2C", backgroundColor: "#FFE8E1" },
      PARTIALLY_COMPLETED: { color: "#DD8A0D", backgroundColor: "#FEFFE1" },
    };

    // normalize value: trim, uppercase, replace spaces with underscores
    const status = data?.withdrawal_status
      ?.trim()
      ?.toUpperCase()
      ?.replaceAll(" ", "_");

    const style = colors[status] || {
      color: "#E42C2C",
      backgroundColor: "#FFE8E1",
    };

    return (
      <Button
        sx={{
          backgroundColor: style.backgroundColor,
          color: style.color,
        }}
      >
        {status?.replaceAll("_", " ")}
      </Button>
    );
  },
      },
      // {
      //   key: "payment_status",
      //   label: "Payment Status",
      //   align: "center",
      //   valueRenderer: (data) => {
      //     return (
      //       <Box sx={{ width: "150px" }}>
      //         {/* <Button sx={{  color: '#219653', backgroundColor:' ', fontSize: '14px', borderRadius: '6px' }}  >
      //             Success
      //         </Button> */}
      //         {data?.payment_status == 'Success' ? (
      //           <Button
      //             sx={{
      //               color: "#219653",
      //               backgroundColor:'#21965314',
      //               fontSize: "14px",
      //               borderRadius: "6px",
      //             }}
      //           >
      //             Success
      //           </Button>
      //         ) : (
      //           <Button
      //             sx={{
      //               color: "#E42C2C ",
      //               backgroundColor: "#FFE8E1",
      //               fontSize: "14px",
      //               borderRadius: "6px",
      //             }}
      //           >
      //             Failure
      //           </Button>
      //         )}
      //       </Box>
      //     );
      //   },
      // },
    ];
    if (tokenFlag == "false") {
      let availabletoken = payoutTableColumns.find(
        (item) => item.key == "amount_paid"
      );
      const index = payoutTableColumns.indexOf(availabletoken);
      if (index > -1) {
        payoutTableColumns.splice(index, 1);
      }
    }
    return payoutTableColumns;
  };

  const payoutExcelTableColumns = () => {
    let payoutExcelTableColumns = [
      // {
      //   key: "reference_number",
      //   label: "Payout ID",
      //   align: "left",
      //   fontSize: "15px",
      // },
       {
        key: "reference_number",
        label: "Payment Method",
        align: "left",
        valueRenderer: (data) => {
          return (
            "Payment Request"
            // <Typography sx={{ width: "150px" }}>
            //   {" "}
            //   {/* {data["reference_number"]} */}
            //   {"Payment Request"}
            // </Typography>
          );
        },
      },
      {
        key: "username",
        label: "Player Name",
        align: "left",
        fontSize: "15px",
        //  valueRenderer: (data) => {
        //   return (
        //     <Typography sx={{ width: "150px" }}>
        //       {" "}
        //       {data?.user_details["username"]}
        //     </Typography>
        //   );
        // },
        valueRenderer: (data) => data?.user_details?.username || "N/A",
      },
      {
        key: "email",
        label: "Email",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => data?.user_details?.email || "N/A",
        //  valueRenderer: (data) => {
        //   return (
        //     <Typography>
        //       {" "}
        //       {data?.user_details["email"]}
        //     </Typography>
        //   );
        // },
      },
      {
        key: "mobile",
        label: "Mobile Number",
        align: "left",
        fontSize: "15px",
        //  valueRenderer: (data) => {
        //   return (
        //     <Typography sx={{ width: "150px" }}>
        //       {" "}
        //       {data?.user_details["mobile"]}
        //     </Typography>
        //   );
        // },
        valueRenderer: (data) => data?.user_details?.mobile || "N/A",
      },
      {
        key: "account_name",
        label: "Account Name",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
        return safeDecryptAccountDetails(data?.bank_account_details?.account_name) || "N/A";
      },
        //valueRenderer: (data) => decryptAccountDetails(data?.bank_account_details?.account_name) || "N/A",
      },
      {
        key: "account_number",
        label: "Account Number",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
        return safeDecryptAccountDetails(data?.bank_account_details?.account_number) || "N/A";
      },
        //valueRenderer: (data) => decryptAccountDetails(data?.bank_account_details?.account_name) || "N/A",
      },
        {
        key: "bank_name",
        label: "Bank Name",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
        return data?.bank_account_details?.bank_name || "N/A";
      },
        //valueRenderer: (data) => decryptAccountDetails(data?.bank_account_details?.account_name) || "N/A",
      },
      {
        key: "account_type",
        label: "Account Type",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
        return data?.bank_account_details?.account_type || "N/A";
      },
        //valueRenderer: (data) => decryptAccountDetails(data?.bank_account_details?.account_name) || "N/A",
      },
        {
        key: "bank_address",
        label: "Bank Address",
        align: "left",
        fontSize: "15px",
         valueRenderer: (data) => {
        return data?.bank_account_details?.bank_address || "N/A";
      },
      },
        {
        key: "swift_code",
        label: "Swift Code",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
        return safeDecryptAccountDetails(data?.bank_account_details?.swift_code) || "N/A";
      },
        //valueRenderer: (data) => decryptAccountDetails(data?.bank_account_details?.account_name) || "N/A",
      },
      // {
      //   key: "pot",
      //   label: "Round ID",
      //   align: "left",
      //   fontSize: "15px",

      //   // valueRenderer: (data) => {
      //   //   return (
      //   //     <Typography sx={{ width: '150px' }}> {data["pot"]}</Typography>
      //   //   )
      //   // },
      // },
      {
        key: "request_date",
        label: "Payment Date",
        align: "left",
        valueRenderer: (data) => {
          let date = utcTimetoLocalTimeWithzone(data["request_date"]);
          const [datePart, timePart] = date.split(", ");
          return datePart
        },
      },
      {
        key: "amount",
        label: "Amount Payable",
        align: "left",
        fontSize: "15px",
        valueRenderer: (data) => {
          return `${data?.currency_code} ${data["amount"]}`
        },
      },
      {
        key: "amount_processed",
        label: "Amount Paid",
        align: "left",
        // valueRenderer: (data) => {
        //   return (
        //     <Box sx={{ width: "180px" }}>
        //       <IconButton
        //         sx={{
        //           "&:hover": {
        //             // backgroundColor: 'transparent'
        //             borderRadius: "12px",
        //           },
        //         }}
        //         onClick={() => {
        //           setAmountAdd(true);
        //           setplayerdetails(data);
        //           setAmount(0);
        //           setCurrency(data.currency_code);
        //         }}
        //       >
        //         <Typography
        //           sx={{
        //             color: "#3C50E0",
        //             display: "flex",
        //             gap: 2,
        //             "&:hover": {
        //               backgroundColor: "transparent",
        //             },
        //           }}
        //         >
        //           {data.currency_code} {data.amount_processed}
        //           <Iconify
        //             icon={editicon}
        //             type="image"
        //             size="small"
        //             color="primary.main"
        //           />
        //         </Typography>
        //       </IconButton>
        //     </Box>
        //   );
        // },
        valueRenderer: (data) => data?.amount_processed || "N/A",
      },
      {
        key: "withdrawal_status",
        label: "Payment Status",
        align: "center",
        fontSize: '14px',
        
        valueRenderer: (data) => {
          const colors = {
            COMPLETED :{ color:'#219653',backgroundColor:'#21965333'},
            Failure:{ color:'#E42C2C',backgroundColor:'#FFE8E1'},
            Idle:{ color:'#DD8A0D',backgroundColor:'#FEFFE1'}
          }
          return data?.withdrawal_status
        }
      },
      // {
      //   key: "payment_status",
      //   label: "Payment Status",
      //   align: "center",
      //   valueRenderer: (data) => {
      //     return (
      //       <Box sx={{ width: "150px" }}>
      //         {/* <Button sx={{  color: '#219653', backgroundColor:' ', fontSize: '14px', borderRadius: '6px' }}  >
      //             Success
      //         </Button> */}
      //         {data?.payment_status == 'Success' ? (
      //           <Button
      //             sx={{
      //               color: "#219653",
      //               backgroundColor:'#21965314',
      //               fontSize: "14px",
      //               borderRadius: "6px",
      //             }}
      //           >
      //             Success
      //           </Button>
      //         ) : (
      //           <Button
      //             sx={{
      //               color: "#E42C2C ",
      //               backgroundColor: "#FFE8E1",
      //               fontSize: "14px",
      //               borderRadius: "6px",
      //             }}
      //           >
      //             Failure
      //           </Button>
      //         )}
      //       </Box>
      //     );
      //   },
      // },
    ];
    if (tokenFlag == "false") {
      let availabletoken = payoutExcelTableColumns.find(
        (item) => item.key == "amount_paid"
      );
      const index = payoutExcelTableColumns.indexOf(availabletoken);
      if (index > -1) {
        payoutExcelTableColumns.splice(index, 1);
      }
    }
    return payoutExcelTableColumns;
  };

  const SubmitLeagues = async () => {
    // console.log('submit successfully')
  };

  // const SubmitAmount = async () => {
  //   //post api
  //   try {
  //     if (!loading) {
  //       setLoading(true);
  //      // const response = await Axios.get(`${base_url}/api/accounts/withdrawal/admin/requests/`, Config);
  //       const response = await Axios.put(
  //         // `${base_url}/api/pot/payouts/${playerdetails.id}`,
  //         `${base_url}/api/accounts/withdrawal/admin/requests/${playerdetails.id}/`,
  //         {
  //           // ...userId,
  //           // tokens : parseInt(tokenValue),
  //           amount_processed: Amount,
  //           // payment_type : paymentMode,
  //           // payment_type: "Cash",
  //         },
  //         Config
  //       );
  //       if (response?.status == 200) {
  //         getLeague();
  //       }
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     RefreshToken(error,setErrorMessage,setnotification)  

  //   }

  //   setAmountAdd(false);
  // };

  const SubmitAmount = async () => {
  try {
    if (!loading) {
      setLoading(true);
      const response = await Axios.put(
        `${base_url}/api/accounts/withdrawal/admin/requests/${playerdetails.id}/`,
        {
          amount_processed: Amount,
        },
        Config
      );
      if (response?.status === 200) {
        getLeague();
        setAmountAdd(false); // close modal only if success
      }
      setLoading(false);
    }
  } catch (error) {
    console.log(error, "errorPayout")
    // if backend sends your custom validation error
    if (error.response?.data) {
      const errData = error.response.data;

      // If API response is array (like your example)
      if (Array.isArray(errData) && errData.length > 0) {
        setErrorMessage(errData[0]); // take first error string
        setnotification(true);
      } 
      // If API sends error as string
      else if (typeof errData === "string") {
        setErrorMessage(errData);
        setnotification(true);
      } 
      // Otherwise fallback to RefreshToken
      else {
        RefreshToken(error, setErrorMessage, setnotification);
      }
    } else {
      RefreshToken(error, setErrorMessage, setnotification);
    }

    setLoading(false);
    setAmountAdd(true); // keep modal open so user can retry
  }
};


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const getLeague = useCallback(async () => {
  //   // setpaymentData(data)
  //   try {
  //     if (!loading) {
  //       setLoading(true);
  //      // const response = await Axios.get(`${base_url}/api/pot/payouts`, Config);
  //      const response = await Axios.get(`${base_url}/api/accounts/withdrawal/admin/requests/`, Config);
  //      console.log(response, "response")
  //       if (response?.status == 200) {
  //         console.log(response?.data, "response?.status")
  //         setpaymentData(response?.data?.results?.withdrawal_requests);
  //       }
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     RefreshToken(error,setErrorMessage,setnotification)  

  //   }
  // }, [value]);

   const getLeague = useCallback(async (page = 1, limit = 10, orderBy = '', order = '', search = '') => {
    dispatch(setUsers([]));
    try{
    
        setPopup(false)
        setLoading(true)
  
         // Build query parameters
        let queryParams = `page=${page}&limit=${limit}`;
        
        // Add sorting parameters if provided
        if (orderBy && order) {
          // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
          queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;
  
        }
  console.log(Config, "Config")
         // ADD THIS: Add search parameter if provided
          if (search && search.trim() !== '') {
            queryParams += `&user=${encodeURIComponent(search.trim())}`;
          }
          console.log(`${base_url}/api/accounts/withdrawal/admin/requests/?${queryParams}`,"URLPayouts")
        // const response = await Axios.get(`${base_url}/api/accounts/user/create?type=player`, Config);
        const response = await Axios.get(`${base_url}/api/accounts/withdrawal/admin/requests/?${queryParams}`, Config);
  console.log(response, "Players")
        if (response?.status == 200) {
          // let no = 1
           let startIndex = (page - 1) * limit + 1;
          let data = response?.data?.results?.withdrawal_requests
          data.map(item => {
            item.serial_no = startIndex
            startIndex += 1
          })
          dispatch(setUsers(data));
          setpaymentData(response?.data?.results?.withdrawal_requests);
          setTotalCount(response?.data?.count); // Set total count from API response
  
        }
        setLoading(false)
        setPopup(false)
        
      }
      catch(error){
        RefreshToken(error,setErrorMessage,setnotification)
      }
    }, [users]);

        // Handle pagination change from TransTable
      const handlePageChange = useCallback((page, rowsPerPage) => {
        setCurrentPage(page);
        setRowsPerPage(rowsPerPage);
        // API pages usually start from 1, but MUI pagination starts from 0
        getLeague(page + 1, rowsPerPage, sortBy, sortOrder);
      }, [sortBy, sortOrder, getLeague]);
    
      // Handle sorting change from TransTable
      const handleSortChange = useCallback((orderBy, order) => {
        setSortBy(orderBy);
        setSortOrder(order);
        // Reset to first page when sorting changes
        setCurrentPage(0);
        getLeague(1, rowsPerPage, orderBy, order);
      }, [rowsPerPage, getLeague]);
    
        // ADD THIS: Handle search from TransTable
      const handleSearch = useCallback((searchValue) => {
        setSearchQuery(searchValue);
        // Reset to first page when searching
        setCurrentPage(0);
        getLeague(1, rowsPerPage, sortBy, sortOrder, searchValue);
      }, [rowsPerPage, sortBy, sortOrder, getLeague]);
  

  const downloadExcel = (jsonData, fileName) => { 
    const filteredData = jsonData.map((item) => {
      const newItem = {};
      payoutExcelTableColumns().forEach((col) => {
        if (col.valueRenderer) {
          newItem[col.label] = col.valueRenderer(item);
        } else {
          newItem[col.label] =  item[col.key];
        }
      });
      return newItem;
    });
    
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  useEffect(() => {
    getLeague();
  }, [value]);

  //Excel Get Full Data Using In this Function Start
    const getAllUsersForExcel = async () => {
    try {
      setLoading(true);
      const response = await Axios.get(
        `${base_url}/api/accounts/withdrawal/admin/requests/all/`, // No pagination params
        Config
      );
      
      if (response?.status === 200) {
        setLoading(false);
        console.log(response?.data, "withDrawReqes")
        return response?.data?.data?.withdrawal_requests || response?.data; // Return the data
      }
      setLoading(false);
      return [];
    } catch (error) {
      setLoading(false);
      RefreshToken(error, setErrorMessage, setnotification);
      return [];
    }
  };
  
  // Add state to store all Excel data
  const [allExcelData, setAllExcelData] = useState([]);
  
  // Add this function to handle Excel download
  const handleExcelDownload = async () => {
    try {
      setLoading(true);
      const allUsersData = await getAllUsersForExcel();
      
      if (allUsersData.length > 0) {
        setAllExcelData(allUsersData);
        // Trigger a flag that TransTable can use to download
        setTimeout(() => {
          // This will trigger the download in TransTable
          setAllExcelData(allUsersData);
        }, 100);
      } else {
        // Fallback to current displayed data if API fails
        setAllExcelData(users);
      }
    } catch (error) {
      console.error('Error downloading Excel:', error);
      // Fallback to current displayed data
      setAllExcelData(users);
    } finally {
      setLoading(false);
    }
  };
    //Excel Get Full Data Using In this Function End

    // Enhanced onChange handler for amount validation
// const handleAmountChange = (key, value) => {
//   if (key === "pot_currency") {
//     setCurrency(value);
//   } else {
//     // Handle amount input
//     setAmount(value);
    
//     // Real-time validation
//     const remainingPayable = (playerdetails?.amount || 0) - (playerdetails?.amount_processed || 0);
    
//     if (value <= 0) {
//       setAmountError("Amount must be greater than 0");
//     } else if (value > remainingPayable) {
//       setAmountError(`Amount cannot exceed ${currencySymbols[playerdetails?.currency_code] || playerdetails?.currency_code || "USD"} ${remainingPayable}`);
//     } else {
//       setAmountError(''); // Clear error if valid
//     }
//   }
// };

const handleAmountChange = (key, value) => {
  if (key === "pot_currency") {
    setCurrency(value);
  } else {
    const numericRegex = /^[0-9]*$/;
    
    const stringValue = String(value);
    
    if (!numericRegex.test(stringValue)) {
      return; 
    }
    
    const numericValue = Number(value);
    
    if (isNaN(numericValue)) {
      return; 
    }
    
    setAmount(numericValue);
    
    const remainingPayable = (playerdetails?.amount || 0) - (playerdetails?.amount_processed || 0);
    
    if (numericValue <= 0) {
      setAmountError("Amount must be greater than 0");
    } else if (numericValue > remainingPayable) {
      setAmountError(`Amount cannot exceed ${currencySymbols[playerdetails?.currency_code] || playerdetails?.currency_code || "USD"} ${remainingPayable}`);
    } else {
      setAmountError(''); 
    }
  }
};

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      {/* <Stack
        direction={"row"}
        sx={{ justifyContent: "space-between", px: 6, pt: 3 }}
        alignContent="center"
      >
        <PageTitle pageTitle={"Payouts"} />
        <Box sx={{ marginLeft: "10px", cursor: 'pointer' }}>
                <img width={'50px'} src={Excel} alt="excel"  onClick={()=>downloadExcel(paymentData, "Payouts")}/>
        </Box>
      </Stack> */}
      {/* <TabContext value={value} sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList sx={{ px: 6, pt: 3 }} onChange={handleChange} indicatorColor="secondary" textColor="primary" aria-label="lab API tabs example">
            <Tab label="Failed Payouts" value="Failed Payouts" sx={{ color: value === 'Failed Payouts' ? '#3C50E0 !important' : '#000', cursor: 'pointer' }} />
            <Tab label="Completed Payouts" value="Completed Payouts" sx={{ color: value === 'Completed Payouts' ? '#3C50E0 !important' : '#000', cursor: 'pointer' }} />
          </TabList>
        </Box>
        <TabPanel value="Failed Payouts" sx={{ width: '100%' }}>
          <TransTable
            showSearch={true}
            checkbox={false}
            columns={userTableColumns}
            rows={paymentData}
            showAddBtn={false}
            filter_keys={['league', 'leaguename']}
          />
        </TabPanel>
        <TabPanel value="Completed Payouts" sx={{ width: '100%' }}>
          <TransTable
            showSearch={true}
            checkbox={false}
            columns={userTableColumns}
            rows={paymentData}
            showAddBtn={false}
            filter_keys={['league', 'leaguename']}

          />
        </TabPanel>
      </TabContext> */}
      <TransTable
       pageTitle="Payouts"
          // addBtnTitle={'Change Player Status +'}
          excelColumns ={payoutExcelTableColumns()}
          isExcel={true}
          // addBtnAction={gotoAddUser}
         showSearch={true}
        checkbox={false}
        columns={payoutTableColumns()}
        rows={paymentData}
        showAddBtn={false}
        filter_keys={["username"]}
        isLoading={loading}
           // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
           // ADD THIS: Pass search handler to TransTable
          onSearch={handleSearch}
          searchQuery={searchQuery}
                  //Excel Get Full Data Using In this Function Start
        customExcelData={allExcelData}
        onExcelDownload={handleExcelDownload}

          //Excel Get Full Data Using In this Function End
      />
      <ModalPopUp
        openpopup={amountAdd}
        setPopup={setAmountAdd}
        //title={`${playerdetails?.user_details?.username} | Payable Amount :${currencySymbols["USD"] || playerdetails.currency_code} ${playerdetails?.amount}`}
         title={`${playerdetails?.user_details?.username} | Remaining Payable: ${
    currencySymbols[playerdetails?.currency_code] || playerdetails?.currency_code || "USD"
  } ${(playerdetails?.amount || 0) - (playerdetails?.amount_processed || 0)}`}
        subTitle={"Enter Amount"}
        // subTitle = {`${userId.username} | Available Token : ${userId.available_tokens}`}
        popupType={"payout"}
        //payment methos
        
        // values={{amount:Amount,countryCode:currency,paymentMode:paymentMode}}

        values={{ amount: Amount, countryCode: currency }}
        // onChange={(key, value) => {
        //   if (key == "pot_currency") {
        //     // setpaymentMode(value)
        //     setCurrency(value);
        //   } else {
        //     setAmount(value);
        //   }
        // }}
        onChange={handleAmountChange}
        validationError={amountError}
        onClick={SubmitAmount}
        save={"Yes, Confirm"}
        cancel={"Exit"}
      />
      <ModalPopUp
        openpopup={popup}
        setPopup={setPopup}
        title={"Confirm the action ?"}
        subTitle={"Are you Sure You Want to Change The Status to Completed. "}
        onClick={SubmitLeagues}
        save={"Yes, Confirm"}
        cancel={"Exit"}
      />
      <Notification
        message={errorMessage}
        setopen={setnotification}
        type={"error"}
        show={notification}
      />
    </Box>
  );
}

export default Payouts;
